var TotalJobsGroup = TotalJobsGroup || {};
TotalJobsGroup.Header = TotalJobsGroup.Header || {};

TotalJobsGroup.Config = TotalJobsGroup.Config || {};
TotalJobsGroup.Config.Global = TotalJobsGroup.Config.Global || {};

TotalJobsGroup.Header.UserAgent = TotalJobsGroup.Header.UserAgent || (function ($, config) {
    "use strict";

    var _globalConfig = config;

    function getActualCssMediaWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    };

    function isMobileScreenWidth() {
        return (getActualCssMediaWidth() < _globalConfig.MobileScreenWidth);
    }

    function isMobileSafari() {
        return ($.isNull(navigator.userAgent.match(/(iPod|iPhone|iPad)/gmi)) === false &&
                $.isNull(navigator.userAgent.match(/(AppleWebKit)/gmi)) === false);
    }

    return {
        isMobileScreenWidth: isMobileScreenWidth,
        isMobileSafari: isMobileSafari
    };
})(jQuery, TotalJobsGroup.Config.Global);